import { IKeyStringDict } from "@/types/GlobalTypes";

const CN: IKeyStringDict = {
	"language_code": "cn",
	"txt_language": "语言",
	"txt_info": "信息",
	"txt_userid": "用户名",
	"txt_balance": "余额",
	"txt_online_users": "在线人数",
	"txt_user": "人数",
	"txt_online": "在线",
	"txt_multitable": "多台",
	"txt_exit": "退出",
	"txt_tap_fullscreen": "点击按钮进入全屏模式",
	"txt_lost_connection_server": "链接失败，请刷新浏览器.",
	"txt_no_how_to_play": "No how to play available for this game",
	"txt_no_data_available": "没有数据",
	"txt_all_games": "全部",
	"txt_favorites": "热门",
	"txt_categories": "CATEGORIES",
	"txt_fast-tables_games": "FAST TABLE",
	"txt_dice_games": "骰宝",
	"txt_ball_games": "球类",
	"txt_casino_games": "赌场",
	"txt_other_games": "其他",
	"txt_game_name_m6": "24D轮转",
	"txt_game_name_m7": "鱼虾蟹",
	"txt_game_name_m8": "骰宝6",
	"txt_game_name_m10": "头尾",
	"txt_game_name_m11": "红白格",
	"txt_game_name_m13": "台球",
	"txt_game_name_m14": "骰子扑克",
	"txt_game_name_m16": "滚球",
	"txt_game_name_m19": "猜拳",
	"txt_game_name_m20": "大富翁",
	"txt_game_name_m21": "大富翁世界杯",
	"txt_game_name_m22": "百家乐",
	"txt_game_name_m23": "龙&虎",
	"txt_game_name_m24": "NiuNiu",
	"txt_game_name_m25": "FanTan",
	"txt_game_name_m27": "Shio Fights",
	"txt_game_name_m28": "IDN 4 Stand",
	"txt_game_name_m30": "5D",
	"txt_game_name_m32": "SamGong",
	"txt_game_name_m33": "Gong Ball Jitu",
	"txt_game_name_m34": "HILO",
	"txt_game_name_m35": "48D",
	"txt_game_name_m36": "36D",
	"txt_game_name_p6": "24D",
	"txt_game_name_p7": "轮盘",
	"txt_game_name_p9": "12D",
	"txt_game_name_p12": "骰宝",
	"txt_game_name_m26": "Race Ball",
	"txt_game_name_m29": "3D Shio",
	"txt_game_name_m31": "Sicbo Ball - Fast",
	"txt_game_name_p7b": "Roulette 2 - Fast Table",
	"txt_game_name_m17": "Toto Macau",
	"txt_game_name_m37": "Bingo Sicbo",
	"txt_game_name_m38": "Bingo Baccarat",
	"txt_game_name_m38b": "Bingo Baccarat 2",
	"txt_game_name_m39": "Duel Dice",
	"txt_game_name_m40": "Xoc Dia",
	"txt_game_name_m42": "Pinball",
	"txt_game_name_m50": "Toto Singapore",
	"txt_game_name_m51": "Toto Macau 5D",
	"txt_game_name_toto": "IDN Lotto",
	
	"txt_bet_closed": "停止下注",
	"txt_roadmap": "路线图",
	"txt_history": "历史",
	"txt_statistics": "统计",
	"txt_statistics_first": "STATISTICS 1ST BALL",
	"txt_show_all_roadmap": "显示全部路图",
	"txt_show_all_history": "显示全部历史",
	"txt_play_now": "立即抽奖",
	"txt_new_game_badge": "最新",
	"txt_history_result": "结果历史",
	"txt_history_win": "获胜历史",
	"txt_how_to_play": "玩法",
	"txt_full_screen": "全屏",
	"txt_total_bet": "所有投注",
	"txt_transaction": "交易",
	"txt_news": "最新消息",
	"txt_settings": "设置",
	"txt_promotions": "优惠活动",
	"txt_new_game": "全新游戏",
	"txt_new_features": "最新功能",
	"txt_bonus_history": "奖金记录",
	"txt_memo": "菜单",
	"txt_referral": "推荐",
	"txt_periode": "游戏局数",
	"txt_number": "号码",
	"txt_back": "Back",
	"txt_back_to_lobby_message": "Are you sure you want to go back to Lobby?",
	"txt_yes": "Yes",
	"txt_no": "No",
	"txt_transaction_history": "交易记录",
	"txt_result_history": "历史成绩",
	"txt_number_pagination": "号码.",
	"txt_date": "日期",
	"txt_status": "状态",
	"txt_debit": "借方",
	"txt_credit": "信用",
	"txt_win": "赢",
	"txt_won": "赢了",
	"txt_lose": "输",
	"txt_buy": "买入",
	"txt_refund": "Refund",
	"txt_bet": "下注",
	"txt_guess": "猜测",
	"txt_prize": "奖金",
	"txt_discount": "折扣",
	"txt_x_win": "X-赢",
	"txt_correction": "Correction",
	"txt_total_win": "总赢",
	"txt_total": "总",
	"txt_type": "类型",
	"txt_amount": "金额",
	"txt_touch_to_close": "触摸此处即可关闭",
	"txt_all_odd": "All Odd",
	"txt_all_even": "All Even",
	"txt_all_low": "All Low",
	"txt_all_high": "All High",
	"txt_clear": "全清",
	"txt_undo": "撤回",
	"txt_rebet": "重下",
	"txt_submit": "提交",
	"txt_table_name": "游戏局名",
	"txt_bet_limit": "限注",
	"txt_min_number": "最小下注",
	"txt_max_number": "最大下注",
	"txt_min_50": "最小50",
	"txt_max_50": "最大50",
	"txt_table_information": "Table Information",
	"txt_toggle_streaming": "Toggle Streaming",
	"txt_wait_next_round": "请等待下一局",
	"txt_place_bet": "请下注",
	"txt_bet_close_in": "即将停止下注",
	"txt_video_is_off_desktop_message": "Video is off\nGo to settings to turn on",
	"txt_video_is_off_mobile_message": "Video is off\nTap to turn on",
	"txt_loading_video": "Loading video...",
	"txt_odd_even": "单-双",
	"txt_odd": "单",
	"txt_even": "双",
	"txt_small_big": "小-大",
	"txt_small": "小",
	"txt_big": "大",
	"txt_detail": "细节",
	"txt_red": "红",
	"txt_blue": "蓝",
	"txt_black": "黑",
	"txt_white": "白",
	"txt_head": "头",
	"txt_tail": "尾",
	"txt_banker": "庄",
	"txt_player": "闲",
	"txt_result": "结果",
	"txt_any_double": "Any Double",
	"txt_any_triple": "任意围骰",
	"txt_triple": "围骰",
	"txt_one": "一",
	"txt_two": "二",
	"txt_three": "三",
	"txt_four": "四",
	"txt_five": "五",
	"txt_six": "六",
	"txt_seven": "七",
	"txt_eight": "八",
	"txt_nine": "九",
	"txt_ten": "十",
	"txt_balls_passed_line": "Balls passed line",
	"txt_balls": "ball(s)",
	"txt_on_one_dice": "单骰 1x1",
	"txt_on_two_dice": "双骰 1x2",
	"txt_on_three_dice": "围骰 1x3",
	"txt_shrimp": "虾",
	"txt_chicken": "鸡",
	"txt_jug": "葫芦",
	"txt_crab": "螃蟹",
	"txt_fish": "鱼",
	"txt_2_pairs": "两对",
	"txt_3_of_a_kind": "三条",
	"txt_inc_straight": "混色散牌",
	"txt_flush": "同花",
	"txt_full_house": "葫芦",
	"txt_straight": "顺子",
	"txt_4_of_a_kind": "四条",
	"txt_inc_straight_flush": "同色散牌",
	"txt_straight_flush": "同花顺",
	"txt_5_of_a_kind": "五条",
	"txt_line": "线",
	"txt_row": "线",
	"txt_1st_line": "一线",
	"txt_2nd_line": "二线",
	"txt_3rd_line": "三线",
	"txt_4th_line": "四线",
	"txt_5th_line": "五线",
	"txt_6th_line": "六线",
	"txt_7th_line": "七线",
	"txt_8th_line": "八线",
	"txt_9th_line": "九线",
	"txt_10th_line": "十线",
	"txt_1st_row": "一线",
	"txt_2nd_row": "二线",
	"txt_3rd_row": "三线",
	"txt_4th_row": "四线",
	"txt_2_to_1": "2 TO 1",
	"txt_1st_2nd_line": "一线 & 两线",
	"txt_2nd_3rd_line": "两线 & 三线",
	"txt_3rd_4th_line": "三线 & 四线",
	"txt_4th_5th_line": "四线 & 五线",
	"txt_5th_6th_line": "五线 & 六线",
	"txt_1st_line_2nd_line": "一线 & 两线",
	"txt_3rd_line_4th_line": "两线 & 三线",
	"txt_1_to_18": "1 TO 18",
	"txt_19_to_36": "19 TO 36",
	"txt_left": "左",
	"txt_right": "右",
	"txt_key": "费用 5%",
	"txt_coin": "金钱",
	"txt_jackpot": "Jackpot",
	"txt_pictures": "公",
	"txt_square": "方形",
	"txt_circle": "圆形",
	"txt_others": "其他",
	"txt_either_pair": "任一对子",
	"txt_player_pair": "闲对",
	"txt_perfect_pair": "完美一对",
	"txt_banker_pair": "庄对",
	"txt_tie": "和",
	"txt_tie_on": "Tie On",
	"txt_dice": "Dice",
	"txt_shoe": "牌靴",
	"txt_round_id": "局号",
	"txt_new_shoe_message": "New Shoe in progress\nPlease wait",
	"txt_less_bet": "Less Bet",
	"txt_more_bet": "More Bet",
	"txt_sounds": "声音",
	"txt_music": "音乐",
	"txt_auto_confirm_bet": "自动确认投注",
	"txt_auto_rebet": "自动重新下注",
	"txt_video": "视频",
	"txt_enable_rotation": "启用旋转",
	"txt_batu": "石头",
	"txt_gunting": "剪刀",
	"txt_kertas": "布",
	"txt_jempol": "拇指",
	"txt_telunjuk": "食指",
	"txt_kelingking": "小指",
	"txt_rat": "鼠",
	"txt_ox": "牛",
	"txt_tiger": "虎",
	"txt_rabbit": "兔",
	"txt_dragon": "龙",
	"txt_snake": "蛇",
	"txt_horse": "马",
	"txt_goat": "羊",
	"txt_monkey": "猴",
	"txt_rooster": "鸡",
	"txt_dog": "狗",
	"txt_pig": "猪",
	"txt_tickets": "TICKETS",
	"txt_remove_unwanted_tickets": "Please remove the unwanted tickets before submitting.",
	"txt_submit_to_confirm_rebet": "Click Submit button to confirm Rebet.",
	"txt_no_tickets": "You have no running tickets.",
	"txt_running_tickets": "RUNNING TICKETS",
	"txt_choose_bet_type": "Choose bet type to start.",
	"txt_place_bet_amount": "Please place your bet amount first.",
	"txt_add_tickets": "Add Tickets",
	"txt_choose_bet_type_message": "Please choose Bet Type to start.",
	"txt_remove_unwanted_ticket_message": "Please remove the unwanted tickets before submitting.\nClick Submit button to confirm rebet.",
	"txt_rebet_ticket_message": "You still have rebet tickets!\nTouch \"Show\" to see, then touch Submit to send your bets.",
	"txt_drawing_result": "Drawing Result",
	"txt_m29_first": "First",
	"txt_m29_middle": "Middle",
	"txt_m29_last": "Last",
	"txt_3_pictures": "3 Pictures",
	"txt_any_pictures": "Any Pictures",
	"txt_either_3_picture": "Either 3 Picture",
	"txt_either_any_picture": "Either Any Picture",

	//Gong Ball Jitu
	"txt_gbj_result_message": "To view the live result for the GONG BALL JITU game,  please refer to the GongBall board (left side) on the live streaming.",

	// popup streaming quality
	"txt_popup_streaming_quality": "Please change streaming quality to HD here",

	"txt_action": "行动",

	// bet panel m39
	"txt_m39_red": "Red",
	"txt_m39_blue": "Blue",
	"txt_m39_tie": "Tie",
	"txt_m39_odd": "Odd",
	"txt_m39_even": "Even",
	"txt_m39_low": "Low",
	"txt_m39_high": "High",
	"txt_m39_Odd/Even": "Odd/Even", 
	"txt_m39_Odd/Odd": "Odd/Odd", 
	"txt_m39_Even/Odd": "Even/Odd", 
	"txt_m39_Even/Even": "Even/Even",
	"txt_m39_Low/High": "Low/High", 
	"txt_m39_Low/Low": "Low/Low", 
	"txt_m39_High/Low": "High/Low", 
	"txt_m39_High/High": "High/High",

	// htp m17
	"txt_m17_out-number": "Out Number",
	"txt_m17_4D/3D/2D": "4D/3D/2D",
	"txt_m17_free-plug": "Free Plug",
	"txt_m17_2D-free-plug": "2D Free Plug",
	"txt_m17_plug-dragon": "Plug Dragon",
	"txt_m17_plug-it-in": "Plug it in",
	"txt_m17_middle-edge": "Middle Edge",
	"txt_m17_combination": "Combination", 
	"txt_m17_base": "Base",
	"txt_m17_50-50": "50-50",
	"txt_m17_shio": "Shio",
	"txt_m17_cross": "Cross",
	"txt_m17_flaming-flower": "Flaming Flower",

	// how to play
	"txt_htp_intro": "简介",
	"txt_htp_rules": "规则",
	"txt_htp_placing-bet": "投注类型",
	"txt_htp_bet-desc": "投注说明 & 例子",
    "txt_htp_payout": "赔率",
	"txt_htp_rank": "排名",
	"txt_complete_information": "DETAILED INFORMATION"
};

export default CN;